export function initSlider($) {
	$('.slider').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoHeight:true,
			autoplayHoverPause: true,

			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
		});
	});
}